import { useEffect, useState } from 'react';
import { fetchLatestEvents } from '../../services/fetch-utils';
import { EventDetails } from '../../interfaces/userInterfaces';
import { EventListDisplay } from './CalendarViews/EventListDisplay';
import '../../css/LatestEvents.css';

export const LatestEvents = () => {
  // Start with an empty array — no dummy object that causes a bad first render
  const [events, setEvents] = useState<EventDetails[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    const load = async () => {
      try {
        const res = await fetchLatestEvents();
        if (res?.data && res.data.length > 0) {
          setEvents([...res.data].reverse());
        }
      } catch {
        setError(true);
      } finally {
        setLoading(false);
      }
    };
    load();
  }, []);

  if (loading)
    return <p style={{ color: 'var(--text-muted)', padding: '16px' }}>Loading events…</p>;
  if (error)
    return <p style={{ color: 'var(--text-muted)', padding: '16px' }}>Could not load events.</p>;
  if (events.length === 0)
    return <p style={{ color: 'var(--text-muted)', padding: '16px' }}>No upcoming events.</p>;

  return (
    <ul id="latest-events-container">
      {events.map((event) => (
        <EventListDisplay key={event.id} {...event} />
      ))}
    </ul>
  );
};
